<template>
  <div class="media-upload-item">
    <div class="sample" v-if="!hasStarted" @click="() => { sheet ? toggleSelect() : uploadPic()}">
      <slot></slot>
    </div>
    <div
      class="preview"
      v-if="hasStarted"
      :style="{ backgroundImage: 'url(' + $setPicSize(imagePreview) + ')' }"
    ></div>
    <div class="progress-state" v-show="isUploading">
      <span>正在上传...</span>
    </div>
    <img class="close-btn" v-show="hasEnded" src="../images/close.png" @click="deletePic" />
    <z-actionsheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      @select="onSelect"
    />
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Actionsheet } from '@zz-common/zz-ui';
import setPicSize from '@zz-app/setPicSize'
import { apiLicenseInfoOcr } from '@api/resourceApi'
import { toast } from '../../../native'
import { getCookie, compareVersion, queryParams, isHeroClubByUa, isHunterApp } from '../../../lib/utils'

const query = queryParams()

//  文件上传状态
const fileUploadState = {
  NOT_STARTED: 0,
  UPLOADING: 1,
  ENDED: 2
}
let maxRequestID = 1

export default {
  name: 'SecurePicUploadItem',
  props: {
    type: {
      type: String,
      default: ''
    },
    order: {
      type: String,
      default: ''
    },
    ocr: {
      type: Boolean,
      default: false
    },
    sheet: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'z-actionsheet': Actionsheet
  },
  data() {
    return {
      imagePreview: 'https://pic2.zhuanstatic.com/zhuanzh/96f5d737-0896-45e1-b045-b9cb011a4935.png',
      progress: 0,
      uploadState: fileUploadState.NOT_STARTED,
      show: false,
      sourceCode: query.sourceCode || this.$route.query.sourceCode,
      actions: [
        { name: '开始拍照', value: 1 },
        { name: '从相册上传', value: 2 }
      ],
      isHeroClub: isHeroClubByUa()
    }
  },
  computed: {
    hasStarted() {
      return (
        this.uploadState === fileUploadState.UPLOADING ||
          this.uploadState === fileUploadState.ENDED
      )
    },
    isUploading() {
      return this.uploadState === fileUploadState.UPLOADING
    },
    hasEnded() {
      return this.uploadState === fileUploadState.ENDED
    }
  },
  methods: {
    onSelect(val) {
      this.show = !this.show
      if (val.value == 2) {
        this.uploadPic({ chooseAlbum: 1 })
      } else {
        this.uploadPic()
      }
    },
    toggleSelect() {
      if (native.in('zz') || this.isHeroClub || isHunterApp) {
        this.show = !this.show
      }
    },
    $setPicSize(url) {
      return setPicSize(url, 444, 444)
    },
    uploadPic(params = {}) {
      if (this.uploadState === fileUploadState.UPLOADING) return

      let startTime = 0
      const requestID = maxRequestID++

      this.imagePreview = ''
      this.progress = 0
      this.uploadState = fileUploadState.NOT_STARTED
      let invokeIDCardCamera;
      const zzv = getCookie('v')
      console.log('zzv', zzv);
      //兼容侠客汇
      if (this.isHeroClub || (zzv && compareVersion(zzv, '8.6.0')) || isHunterApp) {
        invokeIDCardCamera = native.wrap('takePhotoOfIDCard')
      } else {
        invokeIDCardCamera = native.wrap('getSystemCamera')
      }
      // const invokeIDCardCamera = native.wrap('takePhotoOfIDCard')

      invokeIDCardCamera(
        {
          requestid: requestID,
          compressQuality: (native.in('zz') || this.isHeroClub) ? '0.5' : '0.9',
          type: '2',
          switchCamera: '1',
          ...params
        },
        (res) => {
          if (!(res && res.code)) return

          if (res.code === '0') {
            if (Number(res.requestId) !== Number(requestID)) return

            this.progress = res.progress
            if (this.uploadState !== fileUploadState.UPLOADING) {
              this.uploadState = fileUploadState.UPLOADING
              startTime = Date.now()
            }

            if (res.photoBase64) {
              console.info('photo--url', res)
              this.imagePreview = res.photoBase64
            }
            if (res.photoString) {
              console.info(res.photoString)
              if (this.ocr) {
                apiLicenseInfoOcr({
                  sourceCode: this.sourceCode,
                  uid: getCookie('uid'),
                  picUrl: res.photoString
                }).then(ocrres => {
                  this.uploadState = fileUploadState.ENDED
                  this.$emit('uploaded', res.photoString, startTime, this.order, ocrres)
                }).catch(err => {
                  this.uploadState = fileUploadState.ENDED
                  this.$emit('uploaded', res.photoString, startTime, this.order)
                  console.log(err)
                })
              } else {
                this.uploadState = fileUploadState.ENDED
                this.$emit('uploaded', res.photoString, startTime, this.order)
              }
            }
          } else {
            this.imagePreview = ''
            this.progress = 0
            this.uploadState = fileUploadState.NOT_STARTED
            console.warn(res.msg || '调起拍照失败')
            toast({
              msg: res.msg || '调起拍照失败',
              style: '2'
            })
          }
        }
      )
    },
    deletePic() {
      this.imagePreview = ''
      this.progress = 0
      this.uploadState = fileUploadState.NOT_STARTED
      this.$emit('uploaded', '', '', this.order)
    }
  }
}
</script>

<style scoped lang="less">
  @import 'MediaUploadItem.less';
</style>
